import * as React from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, Label } from 'reactstrap';
import { AvForm, AvGroup, AvInput, AvField } from 'availity-reactstrap-validation';
// tslint:disable-next-line:no-unused-variable
import { Translate, translate, ICrudGetAction, ICrudGetAllAction, ICrudPutAction } from 'react-jhipster';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { IRootState } from 'app/shared/reducers';

import { IZone } from 'app/shared/model/zone.model';
import { getEntities as getZones } from 'app/entities/zone/zone.reducer';
import { IEvent } from 'app/shared/model/event.model';
import { getEntities as getEvents } from 'app/entities/event/event.reducer';
import { getEntity, updateEntity, createEntity, reset } from './pricing.reducer';
import { IPricing } from 'app/shared/model/pricing.model';
// tslint:disable-next-line:no-unused-variable
import { convertDateTimeFromServer } from 'app/shared/util/date-utils';
import { keysToValues } from 'app/shared/util/entity-utils';

export interface IPricingUpdateProps extends StateProps, DispatchProps, RouteComponentProps<{ id: number }> {}

export interface IPricingUpdateState {
  isNew: boolean;
  zoneId: number;
  eventId: number;
}

export class PricingUpdate extends React.Component<IPricingUpdateProps, IPricingUpdateState> {
  constructor(props) {
    super(props);
    this.state = {
      zoneId: 0,
      eventId: 0,
      isNew: !this.props.match.params || !this.props.match.params.id
    };
  }

  componentDidMount() {
    if (this.state.isNew) {
      this.props.reset();
    } else {
      this.props.getEntity(this.props.match.params.id);
    }

    this.props.getZones();
    this.props.getEvents();
  }

  saveEntity = (event, errors, values) => {
    if (errors.length === 0) {
      const { pricingEntity } = this.props;
      const entity = {
        ...pricingEntity,
        ...values
      };

      if (this.state.isNew) {
        this.props.createEntity(entity);
      } else {
        this.props.updateEntity(entity);
      }
      this.handleClose();
    }
  };

  handleClose = () => {
    this.props.history.push('/entity/pricing');
  };

  zoneUpdate = element => {
    const id = element.target.value.toString();
    if (id === '') {
      this.setState({
        zoneId: -1
      });
    } else {
      for (const i in this.props.zones) {
        if (id === this.props.zones[i].id.toString()) {
          this.setState({
            zoneId: this.props.zones[i].id
          });
        }
      }
    }
  };

  eventUpdate = element => {
    const id = element.target.value.toString();
    if (id === '') {
      this.setState({
        eventId: -1
      });
    } else {
      for (const i in this.props.events) {
        if (id === this.props.events[i].id.toString()) {
          this.setState({
            eventId: this.props.events[i].id
          });
        }
      }
    }
  };

  render() {
    const isInvalid = false;
    const { pricingEntity, zones, events, loading, updating } = this.props;
    const { isNew } = this.state;

    return (
      <div>
        <Row className="justify-content-center">
          <Col md="8">
            <h2 id="rtnApp.pricing.home.createOrEditLabel">
              <Translate contentKey="rtnApp.pricing.home.createOrEditLabel">Create or edit a Pricing</Translate>
            </h2>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col md="8">
            {loading ? (
              <p>Loading...</p>
            ) : (
              <AvForm model={isNew ? {} : pricingEntity} onSubmit={this.saveEntity}>
                {!isNew ? (
                  <AvGroup>
                    <Label for="id">
                      <Translate contentKey="global.field.id">ID</Translate>
                    </Label>
                    <AvInput id="pricing-id" type="text" className="form-control" name="id" required readOnly />
                  </AvGroup>
                ) : null}
                <AvGroup>
                  <Label id="priceLabel" for="price">
                    <Translate contentKey="rtnApp.pricing.price">Price</Translate>
                  </Label>
                  <AvField id="pricing-price" type="text" name="price" />
                </AvGroup>
                <AvGroup>
                  <Label id="ticketTypeLabel">
                    <Translate contentKey="rtnApp.pricing.ticketType">Ticket Type</Translate>
                  </Label>
                  <AvInput
                    id="pricing-ticketType"
                    type="select"
                    className="form-control"
                    name="ticketType"
                    value={(!isNew && pricingEntity.ticketType) || 'PUBLIC'}
                  >
                    <option value="PUBLIC">PUBLIC</option>
                    <option value="CONSIGNMENT">CONSIGNMENT</option>
                    <option value="COMPLEMENTARY">COMPLEMENTARY</option>
                    <option value="DISCOUNT">DISCOUNT</option>
                    <option value="PRIORITY_BOOKING">PRIORITY_BOOKING</option>
                  </AvInput>
                </AvGroup>
                <AvGroup>
                  <Label for="zone.id">
                    <Translate contentKey="rtnApp.pricing.zone">Zone</Translate>
                  </Label>
                  <AvInput id="pricing-zone" type="select" className="form-control" name="zone.id" onChange={this.zoneUpdate}>
                    <option value="" key="0" />
                    {zones
                      ? zones.map(otherEntity => (
                          <option value={otherEntity.id} key={otherEntity.id}>
                            {otherEntity.id}
                          </option>
                        ))
                      : null}
                  </AvInput>
                  <AvInput id="pricing-zone" type="hidden" name="zone.id" value={this.state.zoneId} />
                </AvGroup>
                <AvGroup>
                  <Label for="event.id">
                    <Translate contentKey="rtnApp.pricing.event">Event</Translate>
                  </Label>
                  <AvInput id="pricing-event" type="select" className="form-control" name="event.id" onChange={this.eventUpdate}>
                    <option value="" key="0" />
                    {events
                      ? events.map(otherEntity => (
                          <option value={otherEntity.id} key={otherEntity.id}>
                            {otherEntity.id}
                          </option>
                        ))
                      : null}
                  </AvInput>
                  <AvInput id="pricing-event" type="hidden" name="event.id" value={this.state.eventId} />
                </AvGroup>
                <Button tag={Link} id="cancel-save" to="/entity/pricing" replace color="info">
                  <FontAwesomeIcon icon="arrow-left" />&nbsp;
                  <span className="d-none d-md-inline">
                    <Translate contentKey="entity.action.back">Back</Translate>
                  </span>
                </Button>
                &nbsp;
                <Button color="primary" id="save-entity" type="submit" disabled={isInvalid || updating}>
                  <FontAwesomeIcon icon="save" />&nbsp;
                  <Translate contentKey="entity.action.save">Save</Translate>
                </Button>
              </AvForm>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  zones: storeState.zone.entities,
  events: storeState.event.entities,
  pricingEntity: storeState.pricing.entity,
  loading: storeState.pricing.loading,
  updating: storeState.pricing.updating
});

const mapDispatchToProps = {
  getZones,
  getEvents,
  getEntity,
  updateEntity,
  createEntity,
  reset
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(PricingUpdate);
